import React from "react";
import { motion } from "framer-motion";
import PracticeLeaderShip from "../components/LeaderShip2/LeaderShip";

const LeaderShipScreen = () => (
  <div>
    <motion.div
      initial={{ y: "-100vh", opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.4 }}
    >
      <PracticeLeaderShip />
    </motion.div>
  </div>
);

export default LeaderShipScreen;
